import { lineClamp } from './utils'

export const mixins = {
  lineClamp,
  toolbar: {},
}
